import {Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlValueAccessor} from "@angular/forms";
import {SimpleEntity} from "../../models/simple-entity.model";
import {WarehouseService} from "../../services/warehouse/warehouse.service";
import {AutocompleteAccessor} from "./autocomplete-accessor";
import {CompanyService} from "../../services/company/company.service";
import {BranchService} from "../../services/company/branch.service";
import {WhProductService} from 'src/app/services/wh-product/wh-product.service';
import {AutoComplete} from "primeng/autocomplete";
import {AddressCardService} from "../../services/company/address-card.service";

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [AutocompleteAccessor]
})




export class AutocompleteComponent implements OnInit, ControlValueAccessor, OnChanges {


  @Input() values: any[] = [];
  @Input() field: string = "name";
  @Input() placeholder: string;
  @Input() parentId: number = 0;
  @Input() serviceName: string;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() isDropDown: boolean = false;
  @Input() defaultValue: any = null;
  @Input() params: any = null;
  @Input() focusOutDisable: boolean = false;

  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onClear: EventEmitter<any> = new EventEmitter();
  @Output() focusOut: EventEmitter<any> = new EventEmitter();
  @Output() unSelect: EventEmitter<any> = new EventEmitter();

  @ViewChild(AutoComplete) private autoComplete: AutoComplete;

filtered: SimpleEntity[] = [];

  private services =  {
    'warehouse': {'service': WarehouseService, getAll: true, useFilter: true},
    'company': {'service': CompanyService, getAll: true},
    'branch': {'service': BranchService, getAll: false, useFilter: true},
    'addressCard': {'service': AddressCardService, getAll: false},
    'product': {'service': WhProductService, getAll: false},
    'productCodes': {'service': WhProductService, getAll: false},
    'productByName': {'service': WhProductService, getAll: true},
  }

  private innerValue: any = null;
  items: any[] = [];

  //by the Control Value Accessor
  private onTouchedCallback: () => void =  () => {};
  private onChangeCallback: (_: any) => void =  () => {};

  //get accessor
  get value(): any {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {

    if(value === null) this.innerValue = null;

    if (value !== this.innerValue && !this.value) {
      this.innerValue = null;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }


  constructor(protected injector: Injector) {  }

  Tr2En(text){
    var Maps = {
      "İ":"I","Ş":"S","Ç":"C","Ğ":"G","Ü":"U","Ö":"O",
      "ı":"i","ş":"s","ç":"c","ğ":"g","ü":"u","ö":"o"
    };
    Object.keys(Maps).forEach(function(Old){
      text    = text.replace(Old,Maps[Old]);
    });
    return text;
  }

  filterResult(query) {
    const filtered: any[] = [];
    this.items.forEach(v => {
        if (this.Tr2En(v.name.toLocaleUpperCase('tr-TR')).indexOf(this.Tr2En(query.toLocaleUpperCase('tr-TR'))) === 0)  filtered.push(v);
    });
    return filtered;
  }

  async filter(event) {
    if (event.query.length === 0 && this.items.length > 0) {
      this.filtered = this.items;
      this.autoComplete.show();
      this.autoComplete.loading = false;
    }
    if (event.query.length === 0 && this.values.length > 0) {
      this.filtered = this.values;
      this.autoComplete.show();
      this.autoComplete.loading = false;
    }
    if(!event.query || event.query.length < 3) return;

    if(this.serviceName && this.services[this.serviceName].getAll) {
      this.filtered = this.filterResult(event.query);
    } else {

      // parentId yoksa...
      if(this.parentId != 0 && this.parentId == null) return;

      if(this.params) {
        this.items =  await this.injector.get(this.services[this.serviceName].service).autocomplete(Object.assign(this.params, {query: event.query})).toPromise();
      } else {
          if(this.values.length > 0 ) {
              this.items = this.values;
              this.filtered = this.filterResult(event.query);
              return;
          } else {
              if (this.serviceName) {
                  this.items = this.serviceName === 'productCodes' ? await this.injector.get(this.services[this.serviceName].service).getWhProductCodes((this.parentId || event.query)).toPromise() :
                                                                     await this.injector.get(this.services[this.serviceName].service).autocomplete((this.parentId || event.query)).toPromise();
              }
          }
      }
      if (this.serviceName){
          this.filtered =  this.services[this.serviceName].useFilter ? this.filterResult(event.query) : this.items;
      }else {
          this.filtered = this.filterResult(event.query);
      }
    }
  }

  onFocusOut() {
      if (!this.focusOutDisable){
          this.focusOut.emit(this.value);
          if(!this.value || !this.value.id) this.value = null;
          if(!this.value) this.unSelect.emit();
      }
  }

  async ngOnInit() {
    this.items = this.values;

    if(this.serviceName) {
        if(this.services[this.serviceName].getAll && !this.disabled) {
            this.isDropDown = true;
            this.items = this.serviceName === 'productByName' ? await this.injector.get(this.services[this.serviceName].service).getWhProductsByName(this.params).toPromise() :
                await this.injector.get(this.services[this.serviceName].service).autocomplete(this.params).toPromise();
        }else {
            this.isDropDown = false;
        }
    }


    if(this.defaultValue) this.value = this.defaultValue;

  }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
      if (this.serviceName === 'branch' && changes.parentId?.currentValue){
          this.items = await this.injector.get(this.services[this.serviceName].service).autocomplete(this.parentId).toPromise();
          this.isDropDown = true;
      }
        if (this.serviceName === 'addressCard' && changes.parentId?.currentValue){
            this.items = await this.injector.get(this.services[this.serviceName].service).autocomplete(this.parentId).toPromise();
            this.isDropDown = true;
        }


      if (this.serviceName === 'productByName' && changes.params?.currentValue && !this.disabled) {

            this.items = await this.injector.get(this.services[this.serviceName].service).getWhProductsByName(this.params).toPromise();
            this.isDropDown = true;
      }

      if (this.serviceName === 'company' && changes.defaultValue?.currentValue){
          setTimeout(() => {
              this.value = changes.defaultValue?.currentValue;
          }, 100);

      }
    }
}
